// API 配置 - 所有路径都是相对路径，通过 Nginx 代理
// 路径格式: /api/admin/xxx

export const API_BASE = '/api';

export const API_ENDPOINTS = {
  // 认证
  LOGIN: '/api/admin/auth/login',
  PROFILE: '/api/admin/profile',
  CHANGE_PASSWORD: '/api/admin/profile/change-password',
  
  // 系统配置
  SYSTEM_CONFIG: '/api/admin/system/config',
  STORAGE_TEST: '/api/admin/system/storage/test',
  ANNOUNCEMENTS: '/api/admin/system/announcements',
  ADMINS: '/api/admin/system/admins',
  ROLES: '/api/admin/system/roles',
  
  // 统计数据
  DASHBOARD_STATS: '/api/admin/stats/dashboard',
  
  // 用户管理
  USERS: '/api/admin/users',
  USERS_RECYCLE: '/api/admin/users/recycle',
  
  // 财务管理
  FINANCE_OVERVIEW: '/api/admin/finance/overview',
  FINANCE_TRANSACTIONS: '/api/admin/finance/transactions',
  
  // 模型管理
  MODELS: '/api/admin/models',
  
  // 支付配置
  PAYMENT_CONFIGS: '/api/admin/payment/configs',
  PAYMENT_SAVE: '/api/admin/payment/save',
  PAYMENT_TEST_WECHAT: '/api/admin/payment/test-wechat',
  PAYMENT_TEST_ALIPAY: '/api/admin/payment/test-alipay',
  
  // 短信配置
  SMS_CONFIG: '/api/admin/sms/config',
  SMS_TEST: '/api/admin/sms/test',
  
  // 文件上传
  UPLOAD_AVATAR: '/api/admin/upload/avatar',
  UPLOAD_IMAGE: '/api/admin/upload/image',
};

export default { API_BASE, API_ENDPOINTS };
